import { Stack, Typography } from '@mui/material'
import { DocumentRowValue } from '@/types/documents'
import FieldInfoLabeledValue from './FieldInfoLabeledValue'

type AddressDataProps = {
  jsonValue: NonNullable<DocumentRowValue['final_value_json']>
}

// Formatted like this so that we can use FieldInfoLabeledValue
const addressParts = {
  street1: {
    name: 'Address Line 1',
  },
  street2: {
    name: 'Address Line 2',
  },
  city: {
    name: 'City',
  },
  administrative_area: {
    name: 'State',
  },
  postal_code: {
    name: 'Postal Code',
  },
}

// For backwards compatibility
const oldAddressParts = {
  street1: {
    name: 'Address Line 1',
  },
  street2: {
    name: 'Address Line 2',
  },
  city: {
    name: 'City',
  },
  county: {
    name: 'County',
  },
  state: {
    name: 'State',
  },
  zip: {
    name: 'Postal Code',
  },
  secondary_designator: {
    name: 'Secondary Designator',
  },
  secondary_number: {
    name: 'Secondary Number',
  },
}

export default function AddressData({ jsonValue }: AddressDataProps) {
  const usingNewFormat = Boolean(jsonValue.address)
  const addressConfig = usingNewFormat ? addressParts : oldAddressParts

  return (
    <Stack
      flexGrow={1}
      spacing={1.5}
      p={1.5}
      onMouseDown={(e) => e.preventDefault()}
    >
      <Typography component="h3" variant="subtitle1" sx={{ px: 0.5 }}>
        Address Information
      </Typography>
      {Object.entries(addressConfig).map(([key, label]) => {
        const addressValue = usingNewFormat
          ? jsonValue.address
          : jsonValue.us_address
        const value = usingNewFormat
          ? addressValue?.[key as keyof typeof addressParts]
          : addressValue?.[key as keyof typeof oldAddressParts]
        return <FieldInfoLabeledValue key={key} label={label} value={value} />
      })}
    </Stack>
  )
}
